export default __webpack_public_path__ + "static/media/ultimate-music-china.c78f6b99.png";